import { Editor, Element as SlateElement, Transforms } from "slate";
import type { EntityRef } from "@common/schemas/chatEntityRef.schema";
import { WorkspaceMember } from "@common/types/workspace";
import {
    EntityRefElement,
    MentionElement,
    isInlineElement,
} from "./slateTypes";
import { isUrl as checkIsUrl } from "./slateHelpers";
import { wrapLink } from "./SlateEditor.lib";

const isVoidElement = (element: SlateElement): boolean =>
    element.type === "mention" || element.type === "entityRef";

interface WithInlinesOptions {
    resolvePastedEntityRef?: (text: string) => EntityRef | null;
}

interface WithInlinesOptions {
    resolvePastedEntityRef?: (text: string) => EntityRef | null;
}

export const insertPastedText = ({
    editor,
    text,
    resolvePastedEntityRef,
}: WithInlinesOptions & { editor: Editor; text: string }): boolean => {
    const entityRef = resolvePastedEntityRef?.(text);
    if (entityRef) {
        insertEntityRef(editor, entityRef);
        return true;
    }
    if (checkIsUrl(text)) {
        wrapLink(editor, text);
        return true;
    }
    return false;
};

export const withInlines = (
    editor: Editor,
    { resolvePastedEntityRef }: WithInlinesOptions = {},
) => {
    const { isInline, isVoid, insertData } = editor;

    editor.isInline = (element: SlateElement) =>
        isInlineElement(element) ? true : isInline(element);

    editor.isVoid = (element: SlateElement) =>
        isVoidElement(element) ? true : isVoid(element);

    editor.insertData = (data) => {
        const text = data.getData("text/plain");
        if (
            text &&
            insertPastedText({ editor, text, resolvePastedEntityRef })
        ) {
            return;
        }
        insertData(data);
    };

    return editor;
};

export const insertMention = (editor: Editor, member: WorkspaceMember) => {
    const mention: MentionElement = {
        type: "mention",
        userId: member.user.id,
        name: member.user.firstName,
        children: [{ text: "" }],
    };
    Transforms.insertNodes(editor, mention);
    Transforms.move(editor);
    Transforms.insertText(editor, " ");
};

export const insertEntityRef = (editor: Editor, entityRef: EntityRef) => {
    const element: EntityRefElement = {
        type: "entityRef",
        ...entityRef,
        children: [{ text: "" }],
    };
    Transforms.insertNodes(editor, element);
    Transforms.move(editor);
    Transforms.insertText(editor, " ");
};
